import type { SVGProps } from "react";

/**
 * zoom-in,search-plus
 * @category Interface General
 */
export default function IconZoomIn(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M16.1265 16.1265L20 20M16.1265 16.1265C17.4385 14.8145 18.25 13.002 18.25 11C18.25 6.99594 15.0041 3.75 11 3.75C6.99594 3.75 3.75 6.99594 3.75 11C3.75 15.0041 6.99594 18.25 11 18.25C13.002 18.25 14.8145 17.4385 16.1265 16.1265Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M11 7.75V14.25' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
      <path d='M14.25 11L7.75 11' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}
